<!-- ----------------------------------------------------------------------------------------------------- -->
<!-- Empty layout -->
<!-- ----------------------------------------------------------------------------------------------------- -->
<empty-layout *ngIf="layout === 'empty'"></empty-layout>

<!-- ----------------------------------------------------------------------------------------------------- -->
<!-- Classy layout -->
<!-- ----------------------------------------------------------------------------------------------------- -->
<classy-layout *ngIf="layout === 'classy'"></classy-layout>
